import { useQuery } from "@tanstack/react-query";
import * as api from "../api";
import type { GroupDetail } from "../types";

export const groupKeys = {
  all: ["groups"] as const,
  lists: () => [...groupKeys.all, "list"] as const,
  list: (queryString: string) => [...groupKeys.lists(), queryString] as const,
  details: () => [...groupKeys.all, "detail"] as const,
  detail: (id: number | string) => [...groupKeys.details(), id] as const,
};

export function useGroupQuery(id: number | string | null | undefined) {
  return useQuery<GroupDetail>({
    queryKey: groupKeys.detail(id as number),
    queryFn: () => api.getGroup(id as number),
    enabled: !!id,
    staleTime: 1000 * 60 * 3,
  });
}
